/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

/**
 * Given an source objects, returns its deep copy by using JSON.parse(JSON.stringify(source)).
 * Does not work for Dates, functions, undefined, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas,
 * sparse Arrays, Typed Arrays or other complex types.
 */
export function fastDeepCopy<T>(source: T): T {
    return JSON.parse(JSON.stringify(source));
}
